import { yupResolver } from '@hookform/resolvers/yup';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { useForm } from 'react-hook-form';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { FaFilter } from 'react-icons/fa';
import { CustomButton } from '@Modules/core/components';

interface IFilterFormMeta {
  [x: string]: FormInputMeta,
  schema: any;
}

type Props = {
    meta: any,
} & TFormUIProps;

const FilterFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  const metaLength = Object.keys(meta).length

  return (
        <>
            <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} my={5}>
              <CC.SimpleGrid columns={{ base: 1, md: metaLength>3?(metaLength<4?metaLength-1:2):1, lg: metaLength>3?(metaLength<6?metaLength-1:3):2 }} spacing={10}>
                  {displayCustomInputs<IFilterFormMeta>(meta, register, errors, isLoading)}
              </CC.SimpleGrid>
              <CC.HStack my={4} justifyContent={'flex-end'}>
                <CustomButton disabled={isLoading} isLoading={isSubmitting} type={'submit'}>
                  <FaFilter style={{ marginRight: '10px' }} /> Filter
                </CustomButton>
              </CC.HStack>
            </CC.Box>
        </>
  );
};

export default FilterFormUI;
